<template>
	<div id="group-tab-members"
		 :class="{ 'with-invites': $route.name === 'groups.edit' || (model.allow_user_invites === 1 && $route.name === 'groups.show') }">
		<modal v-if="popup_open && popup_name === 'moderator_warning'" modal_name="moderator_warning"
			   :title="$t('general.warning') + '!'" icon="badge-sheriff" type="medium">
			<template v-slot:modal-content>
				{{ $t('groups.make_moderator_message_1') }} {{ singularName.toLowerCase() }}? {{
					$t('groups.make_moderator_message_2')
				}} {{ singularName.toLowerCase() }}, {{
					$t('groups.make_moderator_message_3')
				}}.
			</template>
			<template v-slot:modal-bottom>
				<div class="subtle-button slim" @click="closePopup">
					{{ $t('fields.cancel') }}
				</div>
				<div class="general-button btn-v2 slim" @click="setMemberStatusTo('moderator')">
					{{ $t('groups.make_moderator') }}
					<i class="far fa-check"></i>
				</div>
			</template>
		</modal>

		<div class="card-v2">
			<div class="card-top tw-justify-between">
				<div class="tw-flex tw-items-center">
					<i class="far fa-users"></i>
					<h3>{{ endpoint_name === 'events' ? $t('events.participants') : $t('groups.members') }}</h3>
				</div>
				<div class="tw-flex tw-items-center  tw-ml-8 slim">
					<!--<div class="search-members tw-flex tw-items-center extra-light-text">
						<input type="text" placeholder="Find user..">
						<i class="fal fa-search"></i>
					</div>-->
					<div class="general-button btn-v2 tw-ml-8 slim" @click="$emit('inviteUsers')"
						 v-if="(($route.name === 'groups.edit' || $route.name === 'events.edit') || $user.isModerator || (((model.allow_user_invites === 1 || model.allow_user_invites === true) && (model.participation !== null && model.participation.role === 'member')) || (model.participation !== null && (['moderator', 'founder'].includes(model.participation.role))))) && !isGroupEvent">
						{{ $t('groups.invite_users') }}
						<i class="far fa-envelope-open"></i>
					</div>
				</div>
			</div>

			<div class="tw-flex tw-items-center tw-mb-3" v-if="typeof model.invited_count !== 'undefined'">
				<p class="tw-pr-4 tw-py-2 tw-mr-4 tw-text-gray-300 tw-border-r tw-border-gray-100 tw-cursor-pointer hover:tw-opacity-75"
				   :class="{ 'active tw-font-semibold secondary-c': member_tab === 'active' }"
				   @click="setMemberTabStatusTo('active')">
					<i class="far fa-check-circle tw-mr-1"></i>
					{{ model.members_count - 1 }} {{ $t('events.present').toLowerCase() }}
				</p>
				<template v-if="!isGroupEvent">
					<p class="tw-pr-4 tw-py-2 tw-mr-4 tw-text-gray-300 tw-border-r tw-border-gray-100 tw-cursor-pointer hover:tw-opacity-75"
					   :class="{ 'active tw-font-semibold secondary-c': member_tab === 'invited' }"
					   @click="setMemberTabStatusTo('invited')">
						<i class="far fa-question-circle tw-mr-1"></i>
						{{ model.invited_count }} {{ $t('events.invited').toLowerCase() }}
					</p>
					<p class="tw-pr-4 tw-py-2 tw-mr-4 tw-text-gray-300 tw-cursor-pointer hover:tw-opacity-75"
					   :class="{ 'active tw-font-semibold secondary-c': member_tab === 'declined' }"
					   @click="setMemberTabStatusTo('declined')">
						<i class="far fa-times-circle tw-mr-1"></i>
						{{ model.declined_count }} {{ $t('events.absent').toLowerCase() }}
					</p>
				</template>
			</div>

			<template v-if="members_loaded">
				<template v-if="activeMembers.length > 0">
					<div class="tw-grid tw-grid-cols-2 tw-gap-x-3 tw-gap-y-3">
						<template
							v-if="user.isModerator || model.participation && ['founder', 'moderator'].includes(model.participation.role)">
							<div class="group-user-select-wrapper tw-relative tw-flex tw-items-center tw-justify-between tw-cursor-pointer tw-border tw-border-white tw-p-2 tw-rounded hover:tw-border-gray-200"
								 :class="{ 'secondary-c-border active': selectedMemberIds.includes(member.id) }"
								 v-for="member in activeMembers" :key="member.id" @click="select(member)">
								<div class="tw-flex tw-items-center tw-mr-2">
									<user-avatar class="tw-mr-4" size="lg" :avatar="member.user.avatar"></user-avatar>
									<p class="tw-flex-1 tw-break-all tw-font-semibold tw-pr-3">{{ member.user.username
										}}</p>
									<i class="fal fa-square tw-absolute tw-right-0 tw-top-0 tw-p-2 tw-text-gray-300 tw-text-xl"
									   :class="{ 'secondary-c': selectedMemberIds.includes(member.id) }"></i>
								</div>
							</div>
						</template>
						<template v-else>
							<div class="tw-flex tw-items-center tw-justify-between" v-for="member in activeMembers"
								 :key="member.id">
								<div class="tw-flex tw-items-center tw-mr-2">
									<user-avatar class="tw-mr-4" size="lg" :avatar="member.user.avatar"></user-avatar>
									<a :href="'/profile/' + member.user.username" target="_blank"
									   class="tw-flex-1 tw-break-all tw-font-semibold hover:tw-underline">{{
											member.user.username
										}}</a>
								</div>
							</div>
						</template>
					</div>

					<div class="tw-mt-5 tw-flex tw-justify-center tw-text-center tw-cursor-pointer secondary-c hover:tw-underline"
						 :class="{ 'tw-opacity-25': currently_paginating }" @click="startPagination(false)"
						 v-if="!pagination_failed && initial_pagination_finished && !lastPage">
						{{ $t('groups.show_more') }}
					</div>
				</template>

				<template v-else>
					<p class="tw-mb-2 tw-text-sm tw-text-gray-500">
						<template v-if="typeof model.invited_count !== 'undefined'">
							{{ $t('groups_and_events.no_members_in_this_category') }}
						</template>
						<template v-else>
							{{ $t('groups.no_active_members_in_group') }} {{ singularName.toLowerCase() }}.
						</template>
					</p>
				</template>
			</template>
			<template v-else>
				<div class="tw-inline-flex tw-mt-5 tw-mb-6">
					<i class="fa fa-spinner fa-spin tw-text-xl tw-text-gray-300"></i>
				</div>
			</template>
		</div>

		<portal to="sidebar" v-if="selected_members.length > 0 && current_tab === 'members'">
			<sidebar-tab title="Selected member(s)" icon="users">
				<template v-if="selected_members.length === 1">
					<div class="selected-group-member-preview tw-flex tw-flex-col tw-mb-2">
						<img :src="selected_members[0].user.avatar">
						<p class="tw-text-lg tw-font-semibold tw-mt-4" v-text="selected_members[0].user.username"></p>
					</div>
				</template>
				<template v-else>
					<div class="tw-flex tw-flex-col tw-mb-2">
						<div class="user-icon-previews">
							<img v-for="selected_member in selected_members" :key="selected_member.id"
								 :src="selected_member.user.avatar" onerror="this.src='/img/avatar.png'">
						</div>
						<p class="tw-text-lg tw-font-semibold tw-mt-4">{{ selected_members.length }} {{
								$t('groups.selected')
							}}</p>
					</div>
				</template>
				<template
					v-if="selected_members.length === 1 && selected_members[0].status !== 'declined' && (user.isModerator || model.participation.role === 'founder')">
					<template v-if="selected_members[0].status !== 'invited' && selected_members[0].role !== 'pending'">
						<p class="tw-flex tw-items-center tw-my-4 tw-text-sm secondary-c tw-cursor-pointer hover:tw-opacity-75"
						   @click="openPopup('moderator_warning')" v-if="selected_members[0].role === 'member'">
							<i class="far fa-badge-sheriff tw-pr-1"></i>
							{{ $t('groups.make_moderator') }}
						</p>
						<p class="tw-flex tw-items-center tw-my-4 tw-text-sm light-text tw-cursor-pointer hover:tw-opacity-75"
						   @click="setMemberStatusTo('member')" v-else-if="selected_members[0].role === 'moderator'">
							<i class="far fa-badge-sheriff tw-pr-1"></i>
							{{ $t('groups.remove_moderator_status') }}
						</p>
					</template>
				</template>
				<p class="tw-mt-4 tw-mb-3 tw-text-sm tw-text-red-500 tw-cursor-pointer hover:tw-opacity-75"
				   @click="remove">
					<i class="far fa-trash tw-pr-1"></i>
					<template v-if="endpoint_name === 'groups'">
						{{ $t('groups.remove_from_group') }} {{ $t('groups.singular').toLowerCase() }}
					</template>
					<template v-else>
						{{ $t('events.remove_from_event') }} {{ $t('events.singular').toLowerCase() }}
					</template>
				</p>
			</sidebar-tab>
		</portal>
	</div>
</template>

<script>
import SimplePagination from '../../../mixins/SimplePagination';
import Global from '../../../mixins/Global';
import Modal from '../../../mixins/v2/Modal';
import Notification from '../../../lib/models/Notification';

export default {
	name: 'GroupTabMembers',

	mixins: [SimplePagination, Global, Modal],

	props: {
		model: {
			required: true,
		},
		endpoint_name: {
			required: true,
			type: String,
		},
		current_tab: {
			required: true,
		},
	},

	data() {
		return {
			members: [],
			members_loaded: false,
			pagination_settings: {
				infinite_scroll: false,
			},
			selected_members: [],
			member_tab: 'active',
		};
	},

	computed: {
		activeMembers() {
			return this.members.filter(member => (member.user !== null));
		},

		selectedMemberIds() {
			return this.selected_members.map(member => member.id);
		},

		selectedMemberUserIds() {
			return this.selected_members.map(member => member.user.id);
		},

		singularName() {
			return this.endpoint_name === 'events' ? this.$t('events.singular') : this.$t('groups.singular');
		},

		pluralName() {
			return this.endpoint_name === 'events' ? this.$t('events.plural') : this.$t('groups.plural');
		},

		isGroupEvent() {
			return this.model.group && this.model.group !== null;
		}
	},

	methods: {
		paginate() {
			const url = `/api/v3/${this.endpoint_name}/${this.model.id}/members`;
			const params = new URLSearchParams();
			let status = 'active';

			if (this.member_tab === 'invited') {
				status = 'invited';
			} else if (this.member_tab === 'declined') {
				status = 'declined';
			}

			params.append('page', this.pagination.current_page ? this.pagination.current_page += 1 : 1);
			params.append('where', `status:${status}`);

			const request = {
				params,
			};

			return new Promise((resolve, reject) => {
				axios.get(url, request).then((result) => {
					this.pagination = result.data.meta;
					this.members = this.members.concat(result.data.data);
					this.members_loaded = true;

					resolve(result);

					this.refreshStickySidebar();
				}).catch(() => {
					alert('Members could not be loaded, please try again later or contact an administrator.');
					reject();
				})
			});
		},

		remove() {
			axios.delete(`/api/v3/${this.endpoint_name}/${this.model.id}/members`, { data: { member_ids: this.selectedMemberUserIds } }).then(() => {
				Notification.insert({
					data: [
						{
							title: this.$t('groups.members_removed'),
						},
					],
				});

				for (let i = 0; i < this.selectedMemberIds.length; i += 1) {
					const member = this.members.find(member => member.id === this.selectedMemberIds[i]);
					const member_index = this.members.findIndex(member => member.id === this.selectedMemberIds[i]);

					if (member.status === 'declined') {
						this.model.declined_count--;
					} else if (member.status === 'invited') {
						this.model.invited_count--;
					} else {
						this.model.members_count--;
					}

					this.members.splice(member_index, 1);
				}

				this.selected_members = [];
			}).catch(() => {
				Notification.insert({
					data: [
						{
							title: this.$t('groups.members_could_not_be_removed'),
							status: 'error',
						},
					],
				});
			});
		},

		setMemberStatusTo(role) {
			const member = this.selected_members[0];

			member.role = role;

			this.closePopup();

			axios.put(`/api/v3/${this.endpoint_name}/${this.model.id}/members/${member.id}/role`, { role: member.role, endpoint_name: this.endpoint_name }).then(() => {
				if (role === 'moderator') {
					Notification.insert({
						data: [
							{
								title: this.$t('groups.member_now_moderator'),
							},
						],
					});
				} else {
					Notification.insert({
						data: [
							{
								title: this.$t('groups.moderator_status_removed'),
							},
						],
					});
				}
			}).catch(() => {
				// revert changes
				if (role === 'moderator') {
					member.role = 'member';
				} else {
					member.role = 'moderator';
				}

				Notification.insert({
					data: [
						{
							title: 'Please try again later.',
							status: 'error',
						},
					],
				});
			});
		},

		select(member) {
			if (!this.selectedMemberIds.includes(member.id)) {
				this.selected_members.push(member);
			} else {
				const index = this.selected_members.findIndex(selected_member => selected_member.id === member.id);

				this.selected_members.splice(index, 1);
			}
		},

		setMemberTabStatusTo(tab) {
			if (this.member_tab !== tab) {
				this.selected_members = [];
				this.members_loaded = false;
				this.members = [];

				this.member_tab = tab;
				this.startPagination(true);
			}
		},
	},

	beforeDestroy() {
		this.selected_members = [];
	},

	deactivated() {
		this.selected_members = [];
	},
};
</script>

<style lang="scss">
#group-tab-members {
	.search-members {
		input {
			border: 0;
			padding: 0;
			font-size: 14px;
			margin-bottom: 0 !important;
			border-radius: 0;

			&:focus {
				&::placeholder {
					color: #c7c7c7 !important;
				}
			}

			@media(max-width: 767px) {
				width: 90px;
			}
		}

		i {
			font-size: 14px;
			margin-right: 0;
		}
	}

	.group-user-select-wrapper {
		i {
			@apply tw-hidden;
		}

		&:hover {
			i {
				@apply tw-block;
			}
		}

		&.active {
			i {
				@apply tw-block;

				&:before {
					content: "\F14A";
				}
			}
		}
	}

	&.with-invites {
		.card-v2 {
			@apply tw-pt-3;

			.card-top {
				@apply tw-pb-3;
			}
		}
	}

	&.without-invites {
		.card-v2 {
			@apply tw-pt-6;

			.card-top {
				@apply tw-pb-6;
			}
		}
	}
}

.selected-group-member-preview {
	img {
		width: 100px;
		height: 100px;
		border-radius: 18px;
		box-shadow: 1px 1px 3px #00000029;
	}
}
</style>